import { LazyAction, LazyModule, preloadScriptChunk } from 'owa-bundling';
export { default as getMoveToMruList } from './actions/getMoveToMruList';
preloadScriptChunk('MoveMruActions');
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "MoveMruActions" */ './lazyIndex');
});
export var lazyAddFolderIdToMoveToMruList = new LazyAction(lazyModule, function (m) { return m.addFolderIdToMoveToMruList; });
export var lazyRemoveFolderIdFromMoveToMruList = new LazyAction(lazyModule, function (m) { return m.removeFolderIdFromMoveToMruList; });
//# sourceMappingURL=index.js.map